import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface SetPublishedConnectionNameParams {
  readonly id: string;
  readonly name: string;
}

export interface SetPublishedConnectionNameResult extends IResult {
}

export class SetPublishedConnectionNameRequest extends Request<SetPublishedConnectionNameParams, SetPublishedConnectionNameResult> {
  constructor(params: SetPublishedConnectionNameParams) {
    super('setPublishedConnectionName', params);
  }
}
